import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button"]
  static values = {
    successMessage: { type: String, default: "Copied!" },
    originalMessage: { type: String, default: "Copy" }
  }

  connect() {
    this.originalText = this.buttonTarget.textContent
  }

  copy() {
    navigator.clipboard.writeText(this.sourceTarget.value).then(() => {
      this.buttonTarget.textContent = this.successMessageValue
      setTimeout(() => {
        this.buttonTarget.textContent = this.originalMessageValue
      }, 2000)
    })
  }
}
